import React from "react";
import Frame from "../../../../Frame/index.js";
import { useFlightCardLuggageController } from "./useFlightCardLuggage.controller.js";
import { Stack, Text } from "@bookingcom/bui-react";
import { CardAncillaries } from "@flights/search-ui";
import { formatFareName } from "@flights/branded-fares";
export const FlightCardLuggageMobile = ({ flight, brandedFareInfo, align = "end" }) => {
    const { luggageList } = useFlightCardLuggageController(flight);
    if (luggageList.length === 0) {
        return null;
    }
    return (React.createElement(Stack, { gap: 0.5, alignItems: align, attributes: { style: { flexShrink: 0 } } },
        brandedFareInfo ? React.createElement(BrandedFareDescription, { brandedFareInfo: brandedFareInfo }) : undefined,
        React.createElement(CardAncillaries, { ancillaries: luggageList })));
};
const BrandedFareDescription = ({ brandedFareInfo }) => {
    return (React.createElement(Frame, null,
        React.createElement(Text, { variant: "small_1", align: "end", color: "neutral" }, formatFareName(brandedFareInfo.fareName))));
};
